import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { CombosService } from '../../services/combos.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {CurpValidator, RfcValidator, NameValidator, CPValidator, MovilValidator} from '../../validators/validator';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import { ConfirmPopComponent } from '../confirm-pop/confirm-pop.component';


@Component({
  selector: 'app-upaeg-fisica',
  templateUrl: './upaeg-fisica.component.html',
  styleUrls: ['./upaeg-fisica.component.css'],
  providers: [UserService, UpaegService, CombosService]
})
export class UpaegFisicaComponent implements OnInit {
  public sessionActive: boolean;
  public message: string;
  public status: string;
  form: FormGroup;
  public redirect = null;

  public estados = [];
  public municipios = [];
  public localidades = [];

  public asentamientos = [];
  public vialidades = [];
  public estadoCivil = [];
  public createUpa = true;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegSerivice: UpaegService,
    private _combosSerivice: CombosService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      idProductor: ['', []],
      noVinculate: ['f', []],
      curp: ['', [Validators.required, CurpValidator]],
      rfc: ['', [RfcValidator]],
      // tslint:disable-next-line:max-line-length
      nombre: ['', [Validators.required, Validators.pattern(/^[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1}([\s]{1,1}[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1})*$/)]],
      // tslint:disable-next-line:max-line-length
      primer_ap: ['', [Validators.required, Validators.pattern(/^[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1}([\s]{1,1}[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1})*$/)]],
      // tslint:disable-next-line:max-line-length
      segundo_ap: [null, [Validators.pattern(/^[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1}([\s]{1,1}[a-z|A-Z|á|é|í|ó|ú|Á|É|Í|Ó|Ú|ñ|Ñ]{1,}[.]{0,1})*$/)]],
      idEdo: ['', [Validators.required, Validators.minLength(1)]],
      idMun: ['', [Validators.required, Validators.minLength(1)]],
      idLoc: ['', [Validators.required, Validators.minLength(1)]],
      idAsenta: ['', [Validators.required, Validators.minLength(1)]],
      nomAcenta: ['', [Validators.required]],
      idVialidad: ['', [Validators.required, Validators.minLength(1)]],
      nomVialidad: ['', [Validators.required]],
      noExterior: ['', [Validators.required]],
      noInterior: ['', []],
      codigoPostal: ['', [Validators.required, Validators.maxLength(5), CPValidator ]],
      referencias: ['', []],
      entreVialidades: ['', []],
      discapacitado: ['', [Validators.required, Validators.minLength(1)]],
      nacionalidad: ['', [Validators.required]],
      idEdoCivil: ['', [Validators.required, Validators.minLength(1)]],
      telefono: [null, [Validators.pattern(/^([0-9]{10,10})$/)]],
      movil: ['', [Validators.required, Validators.pattern(/^([0-9]{10,10})$/)]],
      latitud: ['', [Validators.required]],
      longitud: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */

   this.loadCombos();
   this.getParams();
  }

  openDialogRedirect(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/misupaegs']);
    });
  }

  dialogRedirect(title, text, action, direction): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/' + direction]);
    });
  }

  openDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  confirmCrearUpaeg() {
    const dialogRef = this.dialog.open(ConfirmPopComponent, {
      width: '40%',
      data: {
        titulo: 'Atención',
        // tslint:disable-next-line:max-line-length
        texto: 'Está usted a punto de registrar una unidad de producción, esta quedará vinculada a su cuenta de usuario y no podrá ser modificada o eliminada. ¿Desea continuar con el registro y vinculación de la unidad de producción?',
        confirm: 'Registrar y vincular unidad de producción',
        cancel: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Confirmado');
        this.upaegSerivice.saveUpaeg(this.form.value).subscribe(response => {
          console.log(response);
          if (response.status) {
            this.openDialogRedirect('Información guardada', response.message, 'Cerrar');
          } else {
            this.openDialog('Error', response.message, 'Cerrar');
          }
        }, error => {
            console.log(error);
            this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
        });
      }
    });

  }

  onSubmit(formulario) {
    if (this.createUpa && this.redirect == null) {
      this.confirmCrearUpaeg();
    } else {
      this.upaegSerivice.saveUpaeg(this.form.value).subscribe(response => {
        console.log(response);
        if (response.status) {
          if ( this.redirect == null) {
            this.openDialog('Información guardada', response.message, 'Cerrar');
          } else {
            this.dialogRedirect('Información guardada', response.message, 'Cerrar', 'dueno');
          }
        } else {
          this.openDialog('Error', response.message, 'Cerrar');
        }
      }, error => {
          console.log(error);
          this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
      });
    }
  }

  loadCombos() {
    this._combosSerivice.getEstados().subscribe(response => {
      this.estados = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener los estados', 'Cerrar');
    });


    this._combosSerivice.getAsentamientos().subscribe(response => {
      this.asentamientos = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener los asentamientos', 'Cerrar');
    });

    this._combosSerivice.getVialidades().subscribe(response => {
      this.vialidades = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener las vialidades', 'Cerrar');
    });

    this._combosSerivice.getEdoCivil().subscribe(response => {
      this.estadoCivil = response;
    }, error => {
      console.log(error);
      this.openDialog('Error', 'Error al obtener estados civiles', 'Cerrar');
    });
  }

  onSelectEstado() {
    if (this.form.get('idEdo').valid) {
      this._combosSerivice.getMunicipios(this.form.get('idEdo').value).subscribe(response => {
        this.municipios = response;
        if (this.form.get('idEdo').value === '') {
          this.form.get('idMun').setValue('');
          this.form.get('idLoc').setValue('');
        }
      }, error => {
        console.log(error);
        this.openDialog('Error', 'Error al obtener los municipios', 'Cerrar');
      });

    } else {
      this.municipios = [];
      this.form.get('idMun').setValue('');
      this.form.get('idLoc').setValue('');
    }
  }

  onSelectMun() {
    console.log('entrado en mun');
    if (this.form.get('idEdo').valid && this.form.get('idMun').valid) {
      console.log('Valido localidad');
      this._combosSerivice.getLocalidades(this.form.get('idEdo').value, this.form.get('idMun').value).subscribe(response => {
        this.localidades = response;
        if (this.form.get('idMun').value === '') {
          this.form.get('idLoc').setValue('');
        }
      }, error => {
        console.log(error);
        this.openDialog('Error', 'Error al obtener las localidades', 'Cerrar');
      });
    } else {
      this.localidades = [];
      this.form.get('idLoc').setValue('');
    }
  }

  getEspecificUpaegInfo(idUpaeg) {
    this.upaegSerivice.getUpaegFisica(idUpaeg).subscribe(response => {
      console.log(response);
      if (response.status) {
        response.data.forEach(upaeg => {
          this.form.get('idProductor').setValue(upaeg.id_productor);
          this.form.get('curp').setValue(upaeg.curp);
          this.form.get('curp').disable();
          this.form.get('rfc').setValue(upaeg.rfc);
          this.form.get('rfc').disable();
          this.form.get('nombre').setValue(upaeg.nom_productor);
          this.form.get('nombre').disable();
          this.form.get('primer_ap').setValue(upaeg.ape_paterno);
          this.form.get('primer_ap').disable();
          this.form.get('segundo_ap').setValue(upaeg.ape_materno);
          this.form.get('segundo_ap').disable();
          this.form.get('idEdo').setValue(upaeg.id_edo);
          this.form.get('idMun').setValue(upaeg.id_mun);
          this.form.get('idLoc').setValue(upaeg.id_loc);
          this.form.get('idAsenta').setValue(upaeg.id_tipo_asentamiento);
          this.onSelectEstado();
          this.onSelectMun();
          this.form.get('nomAcenta').setValue(upaeg.nom_asentamiento);
          this.form.get('idVialidad').setValue(upaeg.id_tipo_vialidad);
          this.form.get('nomVialidad').setValue(upaeg.nom_vialidad);
          this.form.get('noExterior').setValue(upaeg.num_ext);
          this.form.get('noInterior').setValue(upaeg.num_int);
          this.form.get('codigoPostal').setValue(upaeg.cp);
          this.form.get('referencias').setValue(upaeg.referencias);
          this.form.get('entreVialidades').setValue(upaeg.entre_vialidades);
          let capacidades = 'f';
          if (upaeg.capacidades_diferentes) {
            capacidades = 't';
          }
          this.form.get('discapacitado').setValue(capacidades);
          this.form.get('nacionalidad').setValue(upaeg.nacionalidad);
          this.form.get('idEdoCivil').setValue(upaeg.id_edo_civil);
          this.form.get('telefono').setValue(upaeg.telefono);
          this.form.get('movil').setValue(upaeg.celular);
        });


      } else {
        this.openDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
          console.log(error);
          this.openDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });


  }

  getParams() {
    this.route.params.subscribe(params => {
      if (params.curp) {
        let parametro = params.curp;
        if (isNaN(parametro)) {
          // LEGB031121HGTDLRA1
          // noVinculate: ['f', []],
          // path: 'upaeg/fisica/:curp/:from',

          if (params.from) {
            this.form.get('noVinculate').setValue('t');
            this.redirect = params.from;
          }




          console.log('Posible CURP');
          this.form.get('curp').setValue(params.curp);
        } else {
          this.createUpa = false;
          console.log('Posible id upaeg');
          this.getEspecificUpaegInfo(parametro);
        }
      }
    });

  }

  setCoords($event){
    console.log($event);
    this.form.get('latitud').setValue($event.lat);
    this.form.get('longitud').setValue($event.lng);
  }

}
